﻿<script setup lang="ts">
    import { type Ref, watch } from 'vue';
    import AiEditor from '@cwd/AiTools/AiEditor.vue';
    import AiSubject from '@cwd/AiTools/AiSubject.vue';
    import AiImages from '@cwd/AiTools/AiImages.vue';
    import koObsToRef, { setupSync } from '@shared/utils/koObsToRef';

    const props = defineProps<{
        tools: {
            createSurvey: {
                show: KnockoutObservable<boolean>;
                selectedSurveyId: KnockoutObservable<string>;
                surveyType: KnockoutObservable<string>;
            };
            editor: {
                contentEditable: any;
                sync: () => unknown;
                show: any;
            };
            subject: {
                show: KnockoutObservable<boolean>;
                text: KnockoutObservable<string>;
            };
            images: {
                show: any;
                clickImageAfterInsert: any;
                imageElement: any;
            };
            viewModel: any;
        };
    }>();

    const aiSubjectShow: Ref<boolean> = koObsToRef(props.tools.subject.show);
    const aiSubjectText: Ref<string> = koObsToRef(props.tools.subject.text);

    watch(aiSubjectShow, (newVal) => {
        if (!newVal || aiSubjectText.value) return;
        setupSync(props.tools.subject.text, aiSubjectText);
    });
</script>

<script lang="ts"></script>

<template>
    <AiEditor :editor="props.tools.editor"></AiEditor>
    <AiSubject :show="aiSubjectShow" :text="aiSubjectText" @update:text="(newVal) => (aiSubjectText = newVal)" @close="aiSubjectShow = false"></AiSubject>
    <AiImages :images="props.tools.images" :viewModel="props.tools.viewModel"></AiImages>
</template>

<style lang="less">
    .ai-initial,
    .ai-result {
        padding: 20px;
        border-radius: 2px;
        box-shadow:
            0 0 0 1px #ccc,
            0 2px 16px -8px #ccc inset;
        background-color: #f5f5f5;

        > div {
            transition: all ease-in-out 300ms;
            opacity: 1;

            > * {
                margin-top: 0;
            }

            *:not(a) {
                color: #1f1c26 !important;
            }
        }
    }

    .ai-result {
        box-shadow:
            0 0 0 1px #1fa9b0,
            0 2px 16px -8px #1fa9b0;
        background-color: #fff;
    }

    .ai-loading {
        position: relative;
        z-index: 0;
        overflow: hidden;

        > div {
            opacity: 0.75;
        }

        &:before {
            content: '';
            position: absolute;
            z-index: -2;
            background-image: conic-gradient(transparent, #1fa9b0 95%, transparent);
            animation: rotate 4000ms linear infinite;
            inset: -9999px;
        }

        &:after {
            content: '';
            position: absolute;
            z-index: -1;
            inset: 3px;
            background-color: #fff;
        }
    }

    @keyframes rotate {
        100% {
            transform: rotate(1turn);
        }
    }

    .btn-group-rounded .btn {
        border-radius: 999px;
    }
</style>

<style scoped lang="less"></style>
